import { ArrowBack, ArrowForward, Close } from '@material-ui/icons';
import { useEffect, useMemo, useState } from 'react';

import { useResponsive } from 'shared/hooks';

import { renderImage, renderVideo } from './utils';
import { Media, Image } from './types';
import {
  CarouselButton,
  CarouselContainer,
  CarouselContent,
  Dialog,
  Header,
} from './GalleryCarouselDialog.styles';

interface Props {
  isOpen: boolean;

  /** @deprecated Use `media` instead. */
  images?: Array<Image>;
  media?: Array<Media>;
  activeIndex?: number;

  onClose(): void;
}

export function GalleryCarouselDialog(props: Props) {
  const [index, setIndex] = useState(() => props.activeIndex ?? 0);

  const { isMobile } = useResponsive();

  useEffect(() => {
    setIndex(prev => props.activeIndex ?? prev);
  }, [props.activeIndex, setIndex]);

  const elements = useMemo(() => {
    const media = props.media ?? [];
    /** @deprecated Remove when the `image` props does. */
    const images = props.images ?? [];

    return media.concat(images);
  }, [props.images, props.media]);

  const element = useMemo(() => {
    const element = elements[index];

    if (!element) {
      return null;
    }

    return renderMedia(element);
  }, [elements, index]);

  const canGoBack = index > 0;
  const canGoNext = index < elements.length - 1;
  const showButtons = elements.length > 1;

  const goBack = () => {
    if (canGoBack) {
      setIndex(prev => prev - 1);
    }
  };

  const goNext = () => {
    if (canGoNext) {
      setIndex(prev => prev + 1);
    }
  };

  return (
    <Dialog
      fullWidth
      fullScreen={isMobile}
      maxWidth="lg"
      open={props.isOpen}
      onClose={props.onClose}
    >
      <Header>
        <CarouselButton onClick={props.onClose}>
          <Close fontSize="inherit" />
        </CarouselButton>
      </Header>

      <CarouselContainer>
        {showButtons && (
          <CarouselButton disabled={!canGoBack} onClick={goBack}>
            <ArrowBack fontSize="inherit" />
          </CarouselButton>
        )}

        <CarouselContent>{element}</CarouselContent>

        {showButtons && (
          <CarouselButton disabled={!canGoNext} onClick={goNext}>
            <ArrowForward fontSize="inherit" />
          </CarouselButton>
        )}
      </CarouselContainer>
    </Dialog>
  );
}

const renderMedia = ({ mimetype, ...renderOptions }: Media) => {
  return mimetype === 'video' ? renderVideo(renderOptions) : renderImage(renderOptions);
};
